var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / BA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "22.6666667 20 22.6666667 0 8.66666667 0"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-17.3%",
    y: "-7.5%",
    width: "128.0%",
    height: "125.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.06 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-BA",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Mask-Copy",
    fill: "#0B36B2",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-2",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFD045",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-2",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "17.3333333 18.6666667 16.3905243 18.942809 16.6666667 18 16.3905243 17.057191 17.3333333 17.3333333 18.2761424 17.057191 18 18 18.2761424 18.942809"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-2",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "14.6666667 14.6666667 13.7238576 14.942809 14 14 13.7238576 13.057191 14.6666667 13.3333333 15.6094757 13.057191 15.3333333 14 15.6094757 14.942809"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-2",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "12 10.6666667 11.057191 10.942809 11.3333333 10 11.057191 9.05719096 12 9.33333333 12.942809 9.05719096 12.6666667 10 12.942809 10.942809"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-2",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "9.33333333 6.66666667 8.39052429 6.94280904 8.66666667 6 8.39052429 5.05719096 9.33333333 5.33333333 10.2761424 5.05719096 10 6 10.2761424 6.94280904"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-2",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "6.66666667 2.66666667 5.72385763 2.94280904 6 2 5.72385763 1.05719096 6.66666667 1.33333333 7.60947571 1.05719096 7.33333333 2 7.60947571 2.94280904"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBa);
export default __webpack_public_path__ + "static/media/BA.906a0641ea07efa3fc98eddaccc76903.svg";
export { ForwardRef as ReactComponent };